"use strict";

exports.__esModule = true;
exports.StyledSpacer = void 0;

var _stitches = require("../theme/stitches.config");

const StyledSpacer = (0, _stitches.styled)('span', {
  size: '1px',
  variants: {
    inline: {
      true: {
        display: 'inline-block'
      },
      false: {
        display: 'block'
      }
    }
  },
  defaultVariants: {
    inline: false
  }
});
exports.StyledSpacer = StyledSpacer;